import { render, staticRenderFns } from "./Post.vue?vue&type=template&id=1cb15eb2"
import script from "./Post.vue?vue&type=script&lang=ts"
export * from "./Post.vue?vue&type=script&lang=ts"
import style0 from "./Post.vue?vue&type=style&index=0&id=1cb15eb2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports